import { useTranslation } from 'react-i18next';

import { useAuthContext } from '@myphx-engineering/auth/client';
import {
    Button,
    FilledCard,
    Heading1,
    Heading2,
    HorizontalDivider,
    IconCheckCircle,
    IconWarning,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type {
    MailOrderProviderInfoFragment,
    PharmacyProviderInfoFragment,
} from '../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../../util';
import { LocationInfo } from '../common/LocationInfo';

type SimplifiedOrderConfirmationProps = {
    location: PharmacyProviderInfoFragment | MailOrderProviderInfoFragment;
};

export const SimplifiedOrderConfirmation = ({
    location,
}: SimplifiedOrderConfirmationProps) => {
    const { t } = useTranslation();
    const { disableAuthFlows, isAuthenticated, signUp } = useAuthContext();

    const homeUrl = getAbsoluteRoute('home');

    return (
        <Stack gap="md">
            <Stack align="center" gap="xxs">
                <IconCheckCircle
                    filled
                    variant="rounded"
                    width="2em"
                    height="2em"
                    color="success"
                />
                <Heading1>{t('orderConfirmation.header')}</Heading1>
            </Stack>
            <Stack gap="sm">
                <HorizontalDivider variant="full" />
                <Heading2>{t('previewDetails.heading')}</Heading2>
                <LocationInfo location={location} />
            </Stack>
            {isAuthenticated ? null : (
                <FilledCard
                    color="warning"
                    Icon={IconWarning}
                    header={t('priorAuth.locationCard.header')}
                    footer={
                        <Button
                            fullWidth
                            disabled={disableAuthFlows}
                            onClick={() => signUp(homeUrl)}
                        >
                            {t('orderConfirmation.register.button')}
                        </Button>
                    }
                >
                    {t('orderConfirmation.register.description')}
                </FilledCard>
            )}
        </Stack>
    );
};
